export default (function (node) {
  if (node === node.window) {
    return node;
  }

  return node.nodeType === 9 ? node.defaultView || node.parentWindow : null;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/getWindow.js
// module id = 51
// module chunks = 0